import React from "react";
import { Link, Events, animateScroll as scroller } from "react-scroll";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem
} from "reactstrap";
let headerclass = "";

class SiteNavi extends React.Component {
  state = {
    isOpen: false
  };

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
    if (!this.state.isOpen) {
      headerclass = "menuopen";
    } else {
      headerclass = "";
    }
  };
  componentDidMount = () => {
    Events.scrollEvent.register("begin", function() {
      console.log("begin", arguments);
    });

    Events.scrollEvent.register("end", function() {
      console.log("end", arguments);
    });
  };
  scrollTo = () => {
    scroller.scrollTo("scroll-to-element", {
      duration: 800,
      delay: 0,
      smooth: "easeInOutQuart"
    });
  };
  componentWillUnmount = () => {
    Events.scrollEvent.remove("begin");
    Events.scrollEvent.remove("end");
  };
  render() {
    const { location, title } = this.props;
    return (
      <Navbar id="header" className={headerclass + " header"} light expand="lg">
        <div className="container">
          <NavbarBrand href="#top-section">
            <img src="/img/logo.svg" alt="logo" />
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle}>
            <img
              alt="menu"
              className="menu-toggle"
              src="/img/menu-toggle.png"
            />
            <img alt="menu" className="cross" src="/img/menu-close.png" />
          </NavbarToggler>
          <Collapse className="headerRight" isOpen={this.state.isOpen} navbar>
            <Nav className="navbar-right" navbar>
              <NavItem>
                <Link
                  activeClass="active"
                  className="top-section"
                  to="top-section"
                  offset={-100}
                  spy={true}
                  smooth={true}
                  duration={500}
                >
                  Home
                </Link>
              </NavItem>
              <NavItem>
                <Link
                  activeClass="active"
                  className="aboutsection"
                  to="about-section"
                  spy={true}
                  smooth={true}
                  duration={500}
                >
                  About Us
                </Link>
              </NavItem>
              <NavItem>
                <Link
                  activeClass="active"
                  className="productSection"
                  to="ProductSection"
                  offset={-100}
                  spy={true}
                  smooth={true}
                  duration={500}
                >
                  Products
                </Link>
              </NavItem>
              <NavItem>
                <Link
                  activeClass="active"
                  className="distribution"
                  to="distribution-section"
                  offset={-100}
                  spy={true}
                  smooth={true}
                  duration={500}
                >
                  Distribution
                </Link>
              </NavItem>
              <NavItem>
                <Link
                  activeClass="active"
                  className="contact-section"
                  to="contact-section"
                  offset={-100}
                  spy={true}
                  smooth={true}
                  duration={500}
                >
                  Contact Us
                </Link>
              </NavItem>
            </Nav>
          </Collapse>
        </div>
      </Navbar>
    );
  }
}

export default SiteNavi;



// WEBPACK FOOTER //
// ./src/components/SiteNavi/index.jsx